import { FC, useState } from "react";
import { transformColorFormat, combineAlphaWithColor } from "./Helpers";
import { ColorBox } from 'material-ui-color';

type ColorPickerFieldProps = {
  initialColor: string;
  handleChange: any;
};

const ColorPickerField: FC<ColorPickerFieldProps> = ({ initialColor, handleChange }) => {
  const [color, setColor] = useState(transformColorFormat(initialColor || '#FFFFFF'));

  const handleColorChange = async (newValue: any) => {
    // Update the color state immediately
    setColor(newValue);

    // Then call handleChange asynchronously
    if (handleChange) {
      await handleChange('color', combineAlphaWithColor(newValue.hex));
    }
  };

  return (
    <ColorBox onChange={handleColorChange} value={color} />
  );
};

export default ColorPickerField;
